<template>
  <div class="container">
    <head-nav-bar title="价格查询" :fixed="true" />
    <div class="price-query">
      <div class="sarch">
        <van-search
          v-model="keyword"
          placeholder="请输入搜索关键词"
          @search="onSearch"
        />
      </div>
      <div class="title">类型</div>
      <div class="type-list">
        <div
          class="type-item"
          v-for="item in typeList"
          :key="item.Id"
          @click="onTypeClick(item)"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Search } from "vant";
export default {
  components: {
    [Search.name]: Search
  },
  data() {
    return {
      keyword: "",
      typeList: []
    };
  },
  created() {
    this.fetchTypeList();
  },
  methods: {
    fetchTypeList() {
      this.$post("GoodsPrice_GetPhType", {}).then(res => {
        console.log(res);
        this.typeList = res.data;
      });
    },
    onTypeClick(item) {
      console.log(item);
      this.$router.push({
        name: "priceQueryList",
        query: {
          typeId: item.id,
          typeName: item.text
        }
      });
    },
    onSearch(keyword) {
      console.log(keyword);
      this.$router.push({
        name: "priceQueryList",
        query: {
          keyword: keyword
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.price-query {
  margin-top: 50px;
  .title {
    font-size: 14px;
    color: #999;
    padding: 0 16px;
    margin-top: 20px;
  }
}
.type-list {
  overflow: hidden;
  padding: 0 16px;
  .type-item {
    padding: 6px 15px;
    text-align: center;
    font-size: 14px;
    display: inline-block;
    border-radius: 99px;
    background: #f1f1f1;
    margin-right: 10px;
  }
}
</style>
